<script>
import SimpleCheckbox from "../Checkboxes/SimpleCheckbox.svelte";
import { ApplicationData } from "../../libraries/ApplicationData.js";
import DlocalgoSmartFields from "./DlocalgoSmartFields.svelte";
import { RegisterAccountStore } from "../Checkout/RegisterAccountStore.js";
import { PaymentProviderStore } from "./PaymentProviderStore.js";

const supportedCountries = [
    /*"CO", 
    "AR", 
    "BO", 
    "BR", 
    "CL", 
    "CR", 
    "EC", 
    "GT", 
    "MX", 
    "PA", 
    "PE", 
    "PY", 
    "UY"*/
];

export let checked = false;
export let name_input = "card_id";
/**
 * @type {String|null}
 */
export let country_set;

// Additional props for SmartFields
export let amount = 0;
export let currency = "USD";
export let id_plan = "";
export let membership_type = "";
export let interval = "month";
export let on_success = () => {};
export let on_error = () => {};
export let is_online_context = null;
export let api_host = window.api_host || "";
export let isSupported = false;

// url params
let params = new URLSearchParams(window.location.search);
let use_smart_fields = params.get("use_smart_fields") ?? false;

let smartFieldsComponent;

export async function createToken() {
    if (smartFieldsComponent && $PaymentProviderStore.use_smart_fields) {
        return await smartFieldsComponent.createToken();
    }
    return { token: { id: "dlocalgo_redirect" } };
}

$: userCountry = country_set ?? $RegisterAccountStore?.form?.code_country ?? $ApplicationData?.user?.code_country ?? "";
$: isSupported = supportedCountries.includes(userCountry);
</script>

{#if isSupported}
<div class="dlocalgo-container">
    <SimpleCheckbox has_circle={false} is_column={true} classes="" classes_content="">
        <input type="radio" class="formElements" on:change checked={checked} name="{name_input}" value="dlocalgo">
        <svelte-fragment slot="content">
            <figure class="is-flex is-justify-content-space-between is-align-items-center">
                <div class="container_img is-grid is-align-items-center">
                    <img style="max-width:60px;" src="https://public-bucket.3pod.io/adm/gallery/3pod-payments-dlmq.svg" alt="">
                </div>
                <figcaption class="is-flex is-flex-direction-column is-align-items-end">
                    <div class="has-text-grey fw400 is-flex is-align-items-center is-gap-10">
                        <span>
                            <i class="iconfont has-text-success x-outline-wallet05"></i>
                        </span>
                        <span>
                            <i class="iconfont has-text-primary x-outline-bank"></i>
                        </span>
                        <span>
                            <img style="max-width:40px;" src="https://bucket.3pod.io/adm/gallery/visa-8yas.webp" alt="">
                        </span>
                        <span>
                            <img style="max-width:40px;" src="https://bucket.3pod.io/adm/gallery/mastercard-uetl.webp" alt="">
                        </span>
                    </div>
                    <span class="font-size-12 fw300">
                        Paga con efectivo, transferencia o tarjeta
                    </span>
                </figcaption>
            </figure>
        </svelte-fragment>
    </SimpleCheckbox>

    {#if checked && use_smart_fields === true}
        <div class="field mt-2 ml-5">
            <label class="checkbox font-size-12">
                <input type="checkbox" 
                    checked={$PaymentProviderStore.use_smart_fields} 
                    on:change={(e) => PaymentProviderStore.setUseSmartFields(e.target.checked)}>
                Pagar directamente con tarjeta (SmartFields)
            </label>
        </div>
    {/if}

    {#if checked && $PaymentProviderStore.use_smart_fields}
        <DlocalgoSmartFields 
            bind:this={smartFieldsComponent}
            {amount} 
            {currency} 
            country={userCountry}
            {id_plan}
            {membership_type}
            {interval}
            {on_success}
            {on_error}
            show_submit_button={false}
            
            email={$RegisterAccountStore.form.email || $ApplicationData?.user?.email}
            first_name={$RegisterAccountStore.form.first_name || $ApplicationData?.user?.first_name}
            last_name={$RegisterAccountStore.form.last_name || $ApplicationData?.user?.last_name}
            phone={$RegisterAccountStore.form.phone || $ApplicationData?.user?.phone}
            dial={$RegisterAccountStore.form.dial || $ApplicationData?.user?.dial}
            password={$RegisterAccountStore.form.password}
            password_repeat={$RegisterAccountStore.form.password_repeat}
            code_country={"CO"}
            address={$RegisterAccountStore.form.address}
            state={$RegisterAccountStore.form.state}
            state_code={$RegisterAccountStore.form.state_code}
            city={$RegisterAccountStore.form.city}
            zip_code={$RegisterAccountStore.form.zip_code}
            code_phone_verify={$RegisterAccountStore.form.code_phone_verify}
            {api_host}
            {is_online_context}
        />
    {/if}
</div>
{/if}

<style>
    .dlocalgo-container {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
</style>
